import { CompanyNameFilterModel } from '../../../models/companyNameFilter.model';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class CompanyNameFilter extends FilterCriteria {
  public override title = 'Company Name';
  public override type: FilterTypes = FilterTypes.CompanyName;
  public override selectedCompanies: CompanyNameFilterModel[] = [];

  public override validate(): boolean {
    return true;
  }

  public override toString(): string {
    if (this.selectedCompanies && this.selectedCompanies.length > 0) {
      return 'Company Name: ' + this.selectedCompanies.map((a) => a.companyName).join(',');
    }
    return '';
  }
}
